import { ManfrediteOfferFilterResponse } from './manfredite-offer-filter.response';
export const createMockedManfrediteOfferFilterResponse = (customValues = {}) => {
    const response = new ManfrediteOfferFilterResponse();
    response.id = customValues.id ?? '6792f00a-441a-4330-8485-24c17fc0ae19';
    response.createdAt = customValues.createdAt ?? new Date('2021-10-01T00:00:00.000Z');
    response.manfrediteId = customValues.manfrediteId ?? 1;
    response.criteria = customValues.criteria ?? {
        minSalary: 10000,
        currency: '€',
        offerLanguage: 'EN',
        text: 'frontend',
        remoteOptions: ['remote'],
        techs: [{ id: 1, name: 'Angular' }],
        techRoles: [{ id: 1, name: 'Frontend Developer' }],
        minLanguages: [{ id: 1, name: 'English', level: 'Fluent' }],
        locations: [{ placeId: 'placeId-1234', country: 'Spain', region: 'Madrid', city: 'Madrid', displayName: 'Madrid' }]
    };
    return response;
};
//# sourceMappingURL=manfredite-offer-filter.response.mock.js.map